module.exports = __webpack_public_path__ + "static/media/pizza-fries.c1df6872.jpg";